export default __webpack_public_path__ + "circle-shape-outline.png";